import { render, staticRenderFns } from "./activitiesPage.vue?vue&type=template&id=6c88d2d6&scoped=true"
import script from "./activitiesPage.vue?vue&type=script&lang=ts"
export * from "./activitiesPage.vue?vue&type=script&lang=ts"
import style0 from "./activitiesPage.vue?vue&type=style&index=0&id=6c88d2d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c88d2d6",
  null
  
)

export default component.exports